export default {
  activeLoaders: []
}
